import React, { Component } from 'react';
import Header from '../header/newheader'
import Footer from '../footer/newfooter'
import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser';
import Axios from 'axios'
import { BASE } from '../api/api'
import location from '../assets/locationbl.png'
import cal from '../assets/Calendar.png'
import eventpdf from '../assets/eventpdf.png'
import eventvideo from '../assets/eventvideo.png'


class UpcomingOpen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nid: props.match.params.id,
      earray: localStorage.getItem('uarray') ? JSON.parse(localStorage.getItem('uarray')) : [],
      index: null,
      next: true,
      prev: false,
      title: props.match.params.title
    }
  }
  componentWillMount() {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    if (this.state.earray) {
      console.log('evearray', JSON.stringify({ id: JSON.parse(this.state.nid), title: this.state.title }))
      console.log('evearrayl', this.state.earray.length)
      if (this.state.earray.length == 1) {
        this.setState({
          prev: false,
          next: false
        })
      }
      let index = this.state.earray.findIndex(x => x.id === JSON.parse(this.state.nid))
      if (index) {
        if (index < 0) {
          console.log('eveindex', index)
          this.setState({
            prev: false,
            next: false
          })
        }
        if (index < 1) {
          this.setState({
            prev: false
          })
        }
        else {
          this.setState({
            prev: false
          })
        }
        this.setState({
          index: index
        })
      }
    }

    this.apicall(this.state.nid)
    this.topFunction()
  }
  apicall(id) {
    if (id == this.state.earray[0].id) {
      this.setState({
        prev: false
      })
    }
    else {
      this.setState({
        prev: true
      })
    }
    if (this.state.earray[this.state.index] == this.state.earray[this.state.earray.length - 1]) {
      this.setState({
        next: false
      })
    }
    else {
      this.setState({
        next: true
      })
    }
    Axios.get(BASE + 'jsonapi/node/events?include=field_image,field_event_report&filter[drupal_internal__nid]=' + id)
      .then((data) => {
        if (data.data.data.length === 0) {
          window.location.href = '/404'
        }
        console.log('eventinner', data.data)
        this.setState({
          people: data.data.data[0].attributes,
          bioimg: data.data.data[0].relationships.field_image.data ? BASE + data.data.included[0].attributes.uri.url : '',
          pdf: data.data.data[0].relationships.field_event_report.data ? BASE + data.data.included.filter(item => item.type === "file--document")[0].attributes.uri.url : ''
        })

      })
  }
  handlepageclick1(action) {
    this.setState({
      people: ''
    })
    if (action === "next") {
      this.setState({
        index: this.state.index + 1,
      }, () => {
        this.props.history.push('/upcoming/' + `${this.state.earray[this.state.index].title.replace(/\W+(?!$)/g, '-')}/${this.state.earray[this.state.index].id}`)
        this.apicall(this.state.earray[this.state.index].id)
        this.setState({
          nid: this.state.earray[this.state.index]
        })
      })
      let nextgot = this.state.earray[this.state.index + 1]

      console.log('goted', this.state.getind)
      this.topFunction()
    }
    else if (action === "prev") {
      this.setState({
        index: this.state.index - 1,
      }, () => {
        this.props.history.push('/upcoming/' + `${this.state.earray[this.state.index].title.replace(/\W+(?!$)/g, '-')}/${this.state.earray[this.state.index].id}`)
        this.apicall(this.state.earray[this.state.index].id)
        this.setState({
          nid: this.state.earray[this.state.index]
        })
      })

      this.topFunction()
    }
  }
  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  getReport(eventarray, id) {
    let arr = eventarray.map(a => a.id);
    var a = arr.indexOf(id);
    if (a !== -1)
      return false
    else
      return true
  }
  render() {


    return (
      <div id="event_desc" className='institutions eventpage event-past-inner'>
        <Header />
        {/* <div>
            <img src={this.state.bioimg} height='300' alt='bioimg'/>
            <div>{this.state.people.title}</div>
        </div> */}
        <body className="wiki" >
          <div className="main-content">
            <div className="container">
              <div className='top-content'>
                <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/events'>Events</Link> / {this.state.people ? this.state.people.title : ""}</div>
              </div>
              <div className="row">
                <div className="node-wiki node" style={{ minHeight: '70.1vh', paddingBottom: '4%' }}>
                  {this.state.people ?
                    <div className="group-middle">
                      <div className='event-row'>
                        <div className='left-row'>
                          <div className='heading sub-body-text'>{this.state.people.title}</div>
                          <div className='event-row date-loc'>
                            {this.state.people.field_date ? <span className="first" style={{ display: 'flex', flexDirection: 'row' }}>
                              <span className="dark-blue"><img src={cal} /></span>
                              {this.state.people.field_from_date ? <span><span>{new Date(this.state.people.field_from_date).getDate() + '-' + parseInt(new Date(this.state.people.field_from_date).getMonth() + parseInt(1)) + '-' + new Date(this.state.people.field_from_date).getFullYear()}</span><span style={{ paddingLeft: '3px', paddingRight: '3px' }}> to</span></span> : ''}
                              <div className="field-name-field-body">{this.state.people.field_date[8] + this.state.people.field_date[9] + this.state.people.field_date[4] + this.state.people.field_date[5] + this.state.people.field_date[6] + this.state.people.field_date[7] + this.state.people.field_date[0] + this.state.people.field_date[1] + this.state.people.field_date[2] + this.state.people.field_date[3]}</div>
                            </span> : ''}
                            {this.state.people.field_venue ? <span style={{ display: 'flex', flexDirection: 'row' }}>
                              <span className="dark-blue"><img src={location} /></span>
                              <div className="field-name-field-body">{this.state.people.field_venue}</div>
                            </span> : ''}
                          </div>
                          <div className='event-row'>
                            {this.state.pdf ?
                              <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <img src={eventpdf} alt='icon' />
                                <div className="field-name-field-body webaddr " style={{ width: "70%" }}><a style={{ color: '#165E84 ' }} target="_blank" rel="noopener noreferrer" href={this.state.pdf}>Event Report</a></div>
                              </div> : ''}
                            {this.state.people.field_youtube_link ?
                              <div className=" repo-vids repo-vids-pdf" style={{ display: 'flex', flexDirection: 'row' }}>
                                <img src={eventvideo} alt='icon' />
                                <div className='vids'>
                                  {this.state.people.field_youtube_link.map((data, index) =>
                                    <a target='_blank' href={data.uri}>Event Video</a>
                                  )}
                                </div>
                              </div> : ''}
                          </div>
                          <div className="field-item even text-justify gray-text sub-body-text" property="content:encoded">
                            {ReactHtmlParser(this.state.people.body ? this.state.people.body.value : '')}
                          </div>
                        </div>
                        <div className='right-row'>
                          {this.state.bioimg ? <li className="first" style={{ display: 'flex', flexDirection: 'row', marginTop: "3%" }}>
                            <img src={this.state.bioimg} />
                          </li> : ''}
                        </div>
                      </div>
                    </div>
                    : ''}
                </div>
              </div>
            </div>
            <ul className="public-pagin" style={{ paddingTop: "5%", paddingBottom: "5%" }}>
              <span>
                <span style={{ pointerEvents: this.state.prev ? '' : 'none', color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? 'pointer' : 'not-allowed' }} onClick={() => this.handlepageclick1('prev')} class={this.state.prev ? "arrow prev-arrow" : "arrow prev-arrow disabled"}></span>
                <p style={{ color: this.state.prev ? '#165E84 ' : '' }}>Previous Event</p>
              </span>
              <span>
                <p style={{ color: this.state.next ? '#165E84 ' : '' }}>Next Event</p>
                <span style={{ pointerEvents: this.state.next ? '' : 'none', color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? 'pointer' : 'not-allowed' }} onClick={() => this.handlepageclick1('next')} class={this.state.next ? "arrow" : "arrow disabled"}></span>
              </span>
            </ul>
          </div>
        </body>
        <div><Footer /></div>
      </div>
    )
  }
}


export default UpcomingOpen;
